import script from "./OfferStat.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferStat.vue?vue&type=script&setup=true&lang=js"

import "./OfferStat.vue?vue&type=style&index=0&id=32b3bed6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b3bed6"]])

export default __exports__